import { gql, ApolloClient } from 'apollo-boost';
import {
  AccountVisibility,
  ReportVisibility,
} from 'shared/auth/hooks/useUserActions';
import { SharingType } from './ReportSharingOptions';

const updateOrganizationVisibilityQuery = gql`
  mutation updateAccountVisibility(
    $terms: Boolean!
    $visibility: AccountVisibilityEnum!
    $newProgramVisibility: NewProgramVisibilityEnum!
  ) {
    updateAccountVisibility(
      terms: $terms
      visibility: $visibility
      newProgramVisibility: $newProgramVisibility
    ) {
      success
      error
    }
  }
`;

const getNewProgramVisibility = (
  visibility: AccountVisibility,
  newProgramVisibility: SharingType | undefined,
): ReportVisibility => {
  if (visibility === 'PUBLIC_DEFAULT') return 'PUBLIC';
  if (visibility === 'RESTRICTED_DEFAULT') return 'RESTRICTED';
  return newProgramVisibility === 'public' ? 'PUBLIC' : 'RESTRICTED';
};

export const updateOrganizationVisibility = (
  client: ApolloClient<object>,
  variables: {
    terms: boolean;
    visibility: AccountVisibility;
    newProgramVisibility: SharingType | undefined;
  },
) => {
  return client.mutate<{
    success: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: any;
  }>({
    mutation: updateOrganizationVisibilityQuery,
    variables: {
      ...variables,
      newProgramVisibility: getNewProgramVisibility(
        variables.visibility,
        variables.newProgramVisibility,
      ),
    },
    fetchPolicy: 'no-cache',
  });
};

const updateReportVisibilityQuery = gql`
  mutation updateReportVisibility($id: Int!, $visibility: String!) {
    updateReport(id: $id, visibility: $visibility) {
      success
      error
    }
  }
`;

export const updateReportVisibility = (
  client: ApolloClient<object>,
  variables: {
    reportId: number;
    visibility: ReportVisibility;
  },
) => {
  return client.mutate<{
    success: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: any;
  }>({
    mutation: updateReportVisibilityQuery,
    variables: {
      id: variables.reportId,
      visibility: variables.visibility,
    },
    fetchPolicy: 'no-cache',
  });
};

const updateProgramVisibilityQuery = gql`
  mutation updateProgramVisibility($id: Int!, $visibility: String!) {
    updateProgram(id: $id, visibility: $visibility) {
      id
      success
    }
  }
`;

export const updateProgramVisibility = (
  client: ApolloClient<object>,
  variables: {
    programId: number; // report id
    visibility: ReportVisibility;
  },
) => {
  return client.mutate<{
    id: number;
    success: boolean;
  }>({
    mutation: updateProgramVisibilityQuery,
    variables: {
      id: variables.programId,
      visibility: variables.visibility,
    },
    fetchPolicy: 'no-cache',
  });
};
